import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2 p-3 rounded-lg text-sm error" }
const _hoisted_2 = { class: "flex w-full" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "flex gap-1 self-center ml-auto cursor-pointer text-neutral-125 group hover:text-primary-main active:opacity-80" }

import ErrorIcon from "../icons/ErrorIcon.vue";
import RightArrowIcon from "../icons/RightArrowIcon.vue";
import { changeCase } from "../../helpers";
import { ElementE } from '../../enums';

export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateWidget',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ErrorIcon),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(changeCase)('upgrade required', _unref(ElementE).TITLE)), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(changeCase)('please upgrade the widget to version 4.0.', _unref(ElementE).SUBTITLE)), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('updateInfo', 1)), ["prevent"])),
          class: "font-medium underline"
        }, _toDisplayString(_unref(changeCase)('upgrade now', _unref(ElementE).SUBTITLE)), 1),
        _createVNode(RightArrowIcon)
      ])
    ])
  ]))
}
}

})